package com.zaurh.mapquizmobile.presentation.navigation

sealed class Screen(val route: String) {
    data object HomeScreen : Screen("home_screen")
    data object DailyRewardsScreen: Screen("daily_rewards_screen")
}